import { Component, Input, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-conform',
  templateUrl: './conform.component.html',
  styleUrls: ['./conform.component.css'],
})
export class ConformComponent implements OnInit {
  @Input() message: any;
  @Input() android: boolean;
  iphone: boolean = false;
  constructor(public dialogRef: MatDialogRef<ConformComponent>, public router: Router) {
    //////console.log("hello")
  }

  ngOnInit() {
    if (navigator.userAgent.search("iPhone") != -1) {
      this.iphone = true;
    }
  }
  onYesClick(): void {
    this.dialogRef.close(true);

    if (this.iphone) {
      this.router.navigateByUrl('/appstore')
    }
    else {
      if (navigator.userAgent.search("Android") != -1 && this.android) {
        return this.dialogRef.close('androidPopup');
      }
      else {
        this.router.navigateByUrl('/login')
      }
    }
  }

}
